<template>
	<div class="backdrop mouse-pointer" v-if="isOpen" @click="onClick" />
	<div class="container">
		<div v-if="themeLogo" class="statuses-container theme-logo-container">
			<img :src="themeLogo" alt="" class="theme-logo" />
			<span v-if="themeCaptionKey" class="theme-logo-caption">{{ $t(themeCaptionKey) }}</span>
		</div>
		<ModuleStatuses :isOpen="isOpen" :onClick="onClick" />
		<UnreadEvents @click="closeContainer()" />
		<LicenseAlert @click="closeContainer()" />
		<MapSearch />
		<LicenseQaOverlay />
	</div>
</template>

<script lang="ts">
import { computed, ref } from 'vue';

import { appliedThemeCaptionKey, appliedThemeLogo } from '@/api/uiThemes';

import ModuleStatuses from '@/components/floaters/ModuleStatuses.vue';
import UnreadEvents from '@/components/floaters/UnreadEvents.vue';
import LicenseAlert from '@/components/floaters/LicenseAlert.vue';
import MapSearch from '@/components/floaters/MapSearch.vue';
import LicenseQaOverlay from '@/components/floaters/LicenseQaOverlay.vue';

export default {
	components: {
		ModuleStatuses, UnreadEvents, LicenseAlert, MapSearch, LicenseQaOverlay,
	},
	setup() {
		const isOpen = ref(false);
		const onClick = () => { isOpen.value = !isOpen.value };
		const closeContainer = () => { isOpen.value = false };
		const themeLogo = computed(() => appliedThemeLogo.value);
		const themeCaptionKey = computed(() => appliedThemeCaptionKey.value);

		return {
			isOpen,
			onClick,
			closeContainer,
			themeLogo,
			themeCaptionKey,
		}
	},
}
</script>

<style scoped>
.backdrop {
	position: absolute;
	inset: 0;
	background-color: rgba(0, 0, 0, 0.4);
	z-index: 4;
}

.container {
	position: absolute;
	top: 24px;
	inset-inline-start: 16px;
	z-index: 4;
	display: flex;
	align-items: flex-start;
	pointer-events: none;
}

.theme-logo-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding: 4px 8px;
	gap: 6px;
}

.theme-logo {
	display: block;
	height: 30px;
	object-fit: contain;
	flex-shrink: 0;
}

.theme-logo-caption {
	display: block;
	width: min-content;
	font-size: 10px;
	line-height: 1.1;
}
</style>
